export default __webpack_public_path__ + "static/media/edutech-jfn.612d155a.jpeg";